import { createAsyncThunk } from '@reduxjs/toolkit';
import { IPaymentHistory } from '.';
import {
  AdminApiPaths,
  APIDataProvider,
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api';

export type TAdminGetPaymentHistories = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  startDate?: string;
  endDate?: string;
  userId?: string;
};

export type TAdminCreatePaymentHistoryAdminNote = {
  id: string;
  description: string;
};

export type TAdminDeletePaymentHistoryAdminNote = {
  id: string;
  noteId: string;
};

const apiDataProvider = new APIDataProvider();

const adminGetPaymentHistoriesModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  userId,
  startDate,
  endDate,
}: TAdminGetPaymentHistories) => {
  let path = `${AdminApiPaths.paymentHistory}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (userId) {
    path += `&userId=${userId}`;
  }

  if (startDate) {
    path += `&startDate=${startDate}`;
  }

  if (endDate) {
    path += `&endDate=${endDate}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<IPaymentHistory>>
  >(path);

  return response.data;
};

export const adminGetPaymentHistories = createAsyncThunk(
  '/admin/payment-history/list',
  adminGetPaymentHistoriesModule
);

export const adminCreatePaymentHistoryAdminNote = createAsyncThunk(
  '/admin/payment-history/admin-notes/create',
  async (data: TAdminCreatePaymentHistoryAdminNote) => {
    const response = await apiDataProvider.post<TApiResponse<IPaymentHistory>>(
      `${AdminApiPaths.paymentHistory}/admin-notes/${data.id}`,
      data
    );

    return response.data;
  }
);

export const adminDeletePaymentHistoryAdminNote = createAsyncThunk(
  '/admin/payment-history/admin-notes/delete',
  async ({ id, noteId }: TAdminDeletePaymentHistoryAdminNote) => {
    const response = await apiDataProvider.delete<
      TApiResponse<IPaymentHistory>
    >(
      `${AdminApiPaths.paymentHistory}/admin-notes/${id}?id=${id}&noteId=${noteId}`
    );

    return response.data;
  }
);
